export const resolveQuizEnrolmentId = (search = "", navigationState = {}) =>
  new URLSearchParams(search).get("enrolmentId") || navigationState?.enrolmentId || "";

export const hydrateQuizDraftAnswers = (rows = []) => {
  const answers = {};
  (rows || []).forEach((row) => {
    const questionId = row?.questionId || row?.question?._id || row?.question;
    if (!questionId) return;
    answers[String(questionId)] = (row?.selectedOptionIds || []).map(String);
  });
  return answers;
};

export const buildQuizAnswersPayload = (questions = [], answers = {}) =>
  (questions || []).map((question) => ({
    questionId: question.id,
    selectedOptionIds: answers[question.id] || [],
  }));
